/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultGovernorateInfo } from '../models/list-query-result-governorate-info';
import { CreateGovernorateCommand } from '../models/create-governorate-command';
import { UpdateGovernorateCommand } from '../models/update-governorate-command';
@Injectable({
  providedIn: 'root',
})
class GovernorateService extends __BaseService {
  static readonly GetAllPath = '/api/organization/governorates';
  static readonly CreateGovernoratePath = '/api/organization/governorates';
  static readonly GetUpdateGovernoratePath = '/api/organization/governorates/{id}/update';
  static readonly UpdateGovernoratePath = '/api/organization/governorates/{id}/update';
  static readonly DeleteGovernoratePath = '/api/organization/governorates/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `GovernorateService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `inMyLocationGroupsOnly`:
   *
   * - `countryId`:
   *
   * @return Success
   */
  GetAllResponse(params: GovernorateService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultGovernorateInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.inMyLocationGroupsOnly != null) __params = __params.set('inMyLocationGroupsOnly', params.inMyLocationGroupsOnly.toString());
    if (params.countryId != null) __params = __params.set('countryId', params.countryId.toString());
    if (params.regionId != null) __params = __params.set('regionId', params.regionId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/governorates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultGovernorateInfo>;
      })
    );
  }
  /**
   * @param params The `GovernorateService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `inMyLocationGroupsOnly`:
   *
   * - `countryId`:
   *
   * @return Success
   */
  GetAll(params: GovernorateService.GetAllParams): __Observable<ListQueryResultGovernorateInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultGovernorateInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateGovernorateResponse(command?: CreateGovernorateCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/organization/governorates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateGovernorate(command?: CreateGovernorateCommand): __Observable<null> {
    return this.CreateGovernorateResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateGovernorateResponse(id: string): __Observable<__StrictHttpResponse<UpdateGovernorateCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/governorates/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateGovernorateCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateGovernorate(id: string): __Observable<UpdateGovernorateCommand> {
    return this.GetUpdateGovernorateResponse(id).pipe(
      __map(_r => _r.body as UpdateGovernorateCommand)
    );
  }

  /**
   * @param params The `GovernorateService.UpdateGovernorateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateGovernorateResponse(params: GovernorateService.UpdateGovernorateParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/organization/governorates/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `GovernorateService.UpdateGovernorateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateGovernorate(params: GovernorateService.UpdateGovernorateParams): __Observable<null> {
    return this.UpdateGovernorateResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteGovernorateResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/organization/governorates/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteGovernorate(id: string): __Observable<null> {
    return this.DeleteGovernorateResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module GovernorateService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
    inMyLocationGroupsOnly?: boolean;
    countryId?: string;
    regionId?: string;
  }

  /**
   * Parameters for UpdateGovernorate
   */
  export interface UpdateGovernorateParams {
    id: string;
    command?: UpdateGovernorateCommand;
  }
}

export { GovernorateService }
